import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { RouterService } from 'src/app/core/router.service';
import { environment } from 'src/environments/environment';
import { PopUp } from '../../models';

@Component({
	selector: 'pk-broker-takeover-pop-up-modal',
	templateUrl: './takeover-pop-up-modal.component.html',
	styleUrls: ['./takeover-pop-up-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TakeoverPopUpModalComponent {
	// inputs
	public popUp: Subset<PopUp>;

	public environment = environment;

	constructor(
		private activeModal: BsModalRef,
		private routerService: RouterService,
	) {}

	public close(): void {
		this.activeModal.hide();
	}

	public async submit(): Promise<void> {
		this.close();
		if (this.popUp.callToActionDestinationUrl.startsWith('http')) {
			window.open(this.popUp.callToActionDestinationUrl, '_blank');
			return;
		} else {
			await this.routerService.navigate([this.popUp.callToActionDestinationUrl]);
		}
	}
}
